// src/pages/LogoSection.jsx
import React, { useState, useEffect } from "react";
import { getSettings } from "../../services/settingsServices";

// (optionnel) rend /uploads/... absolu vers l’API
const toAbsolute = (u) => {
  if (!u) return "";
  const s = String(u).trim();
  if (/^https?:\/\//i.test(s) || s.startsWith("data:") || s.startsWith("blob:"))
    return s;
  if (!s.startsWith("/uploads")) return s;
  const base = process.env.REACT_APP_API_URL?.replace(/\/$/, "") || "";
  return `${base}${s}`;
};

const LogoSection = () => {
  const [settings, setSettings] = useState({
    nom_comite: "",
    shortname_comite: "",
    logo_comite: "",
  });

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const data = await getSettings();
        if (data.length > 0) {
          setSettings(data[0]);
        }
      } catch (error) {
        console.error("Erreur lors du chargement des settings", error);
      }
    };

    fetchSettings();
  }, []);

  const clubName =
    window.innerWidth < 400
      ? settings.shortname_comite
      : settings.nom_comite;

  return (
    <div className="flex items-center">
      <img
        className="h-16 sm:h-16 lg:h-16 object-contain bg-white/90 p-1"
        src={toAbsolute(settings.logo_comite) || "/img/logo_club.png"}
        alt="Logo comité"
      />
      <div className="ml-2">
        <div className="text-sm sm:text-xl lg:text-2xl font-bold uppercase text-slate-50 leading-tight">
          {clubName || "Association"}
        </div>
      </div>
    </div>
  );
};

export default LogoSection;
